import { useEffect } from 'react';
import { Stack } from 'ui';

import { PartOne } from './PartOne';
import { PartThree } from './PartThree';
import { PartTwo } from './PartTwo';

export const AiBriquetteGuide = ({ currentStep, obfuscateAi }: { currentStep: number; obfuscateAi: boolean }) => {
  useEffect(() => {
    const element = document.getElementById('ai-briquette-guide');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [currentStep]);

  return (
    <Stack
      id="ai-briquette-guide"
      sx={{
        gap: 2,
      }}
    >
      {currentStep === 1 ? <PartOne obfuscateAi={obfuscateAi} /> : null}
      {currentStep === 2 ? <PartTwo /> : null}
      {currentStep === 3 ? <PartThree /> : null}
    </Stack>
  );
};
